<script>
import SustSidebar from '@/components/SustSidebar.vue';

/**
 * @typedef {object} NavbarItem
 * @property {string} name_key
 * @property {string | undefined} icon_key
 * @property {boolean} is_shown
 * @property {boolean} is_open
 * @property {string | undefined} path
 * @property {NavbarItem[] | undefined} children
 */

export default {
    components: {
        SustSidebar,
    },

    computed: {
        deny_padding() {
            return this.no_padding_routes.includes(this.$route.name);
        }
    },

    data() {
        return {
            /**@type {NavbarItem[]} */
            navbar_items: [
                { 
                    name_key: 'user_profile',
                    icon_key: undefined,
                    is_shown: true,
                    is_open: false,
                    path: '/admin-panel/user-profile',
                    children: [],
                },
                { 
                    name_key: 'my_team',
                    icon_key: undefined,
                    is_shown: true,
                    is_open: false,
                    path: undefined,
                    children: [
                        {
                            name_key: 'team_members',
                            icon_key: undefined,
                            is_shown: this.$user.role_id <= 4,
                            is_open: false,
                            path: `/admin-panel/team-members?parent=1`,
                            children: [],
                        },
                        {
                            name_key: 'metric_assignments',
                            icon_key: undefined,
                            is_shown: this.$user.role_id <= 4,
                            is_open: false,
                            path: '/admin-panel/metric-assignments?parent=1',
                            children: [],
                        },
                        {
                            name_key: 'carbon_assignments',
                            icon_key: undefined,
                            is_shown: this.$user.role_id <= 4,
                            is_open: false,
                            path: '/admin-panel/carbon-assignments?parent=1',
                            children: [],
                        },
                        {
                            name_key: 'permissions_page',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/permissions?parent=1',
                            children: [],
                        },
                        {
                            name_key: 'logs',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/logs?parent=1',
                            children: [],
                        },
                    ],
                },
                { 
                    name_key: 'company',
                    icon_key: undefined,
                    is_shown: true,
                    is_open: false,
                    path: undefined,
                    children: [
                        {
                            name_key: 'company_information',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/company-information?parent=2',
                            children: [],
                        },
                        {
                            name_key: 'all_companies',
                            icon_key: undefined,
                            is_shown: this.$user.role_id === 1,
                            is_open: false,
                            path: '/admin-panel/all-companies?parent=2',
                            children: [],
                        },
                        {
                            name_key: 'licence',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/licence?parent=2',
                            children: [],
                        },
                        {
                            name_key: 'supplier_metric_requests',
                            icon_key: undefined,
                            is_shown: this.$user.role_id <= 4,
                            is_open: false,
                            path: '/admin-panel/supplier-metric-requests?parent=2',
                            children: [],
                        },
                    ],
                },
                { 
                    name_key: 'additional_settings',
                    icon_key: undefined,
                    is_shown: this.$user.role_id === 1,
                    is_open: false,
                    path: undefined,
                    children: [
                        {
                            name_key: 'app_state',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/app-state?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'metrics',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/metrics?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'sector',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=sector',
                            children: [],
                        },
                        {
                            name_key: 'category',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=category',
                            children: [],
                        },
                        {
                            name_key: 'element',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=element',
                            children: [],
                        },
                        {
                            name_key: 'target_area',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=target_area',
                            children: [],
                        },
                        {
                            name_key: 'target',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=target',
                            children: [],
                        },
                        {
                            name_key: 'kpi',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=kpi',
                            children: [],
                        },
                        {
                            name_key: 'metric',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=metric',
                            children: [],
                        },
                        {
                            name_key: 'sub_metric',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=sub_metric',
                            children: [],
                        },
                        {
                            name_key: 'global_goal',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=global_goal',
                            children: [],
                        },
                        {
                            name_key: 'sub_goal',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=sub_goal',
                            children: [],
                        },
                        {
                            name_key: 'green_deal',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings?parent=3&item=green_deal',
                            children: [],
                        },
                        {
                            name_key: 'prompts',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/prompts?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'iso-categories',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/iso-categories?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'iso-sub-categories',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/iso-sub-categories?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'hotel-stay-factors',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/hotel-stay-factors?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'electric-factors',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/electric-factors?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'gwp-groups',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/gwp-groups?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'gwp-factors',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/gwp-factors?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'iso-sectors',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/iso-sectors?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'combustion-types',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/combustion-types?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'mobility-types',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/mobility-types?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'combustion-categories',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/combustion-categories?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'combustion-factors',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/combustion-factors?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'refrigerant-factors',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/refrigerant-factors?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'epa-sectors',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/epa-sectors?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'epa-factors',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/epa-factors?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'defra-scopes',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/defra-scopes?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'defra-categories',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/defra-categories?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'defra-activities',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/defra-activities?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'defra-types',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/defra-types?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'defra-fuels',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/defra-fuels?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'defra-units',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/defra-units?parent=3',
                            children: [],
                        },
                        {
                            name_key: 'defra-factors',
                            icon_key: undefined,
                            is_shown: true,
                            is_open: false,
                            path: '/admin-panel/additional-settings/defra-factors?parent=3',
                            children: [],
                        },
                    ],
                },
                { 
                    name_key: 'dashboard',
                    icon_key: undefined,
                    is_shown: true,
                    is_open: false,
                    path: '/dashboard',
                    children: [],
                },
            ],

            no_padding_routes: ['Metrics']
        }
    },

    beforeMount() {
        if (this.$route.path === '/admin-panel') {
            this.$router.push('/admin-panel/user-profile');
        }
    },
}
</script>

<template>
    <div class="admin-panel-main-frame flex-all-centered-row">
        <sust-sidebar 
            :items="navbar_items" 
            style="flex: 1 !important;"
        />
        <div class="router-view" 
            :class="{
                'deny-padding': deny_padding
            }"
        >
            <router-view style="overflow: visible;" />
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .admin-panel-main-frame {
        height: 100%;
        align-items: flex-start;
        overflow: hidden !important;
    }

    .router-view {
        flex: 7 !important; 
        padding: 1em 2em 5em 2em;
        height: 100%;
        overflow-y: auto;
        animation: FadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }

    .deny-padding {
        padding: 0 !important;
        overflow-y: hidden !important;
        overflow-x: hidden !important;
    }

    @keyframes FadeIn {
        from {
            opacity: 0;
        } to {
            opacity: 1;
        }
    }
</style>